<script setup lang="ts">
  import { useMagicKeys, whenever } from '@vueuse/core'

  const keys = useMagicKeys()
  const { show } = DialogController.use()

  const { isQaOrDevelopment } = DevModeHelpers.use()

  whenever(keys['Shift+Ctrl+S'], () => {
    if (isQaOrDevelopment.value) {
      show('shopping-for-someone-else-modal')
    }
  })

  whenever(keys['Shift+Ctrl+A'], () => {
    if (isQaOrDevelopment.value) {
      show('applying-for-someone-else-modal')
    }
  })
</script>

<template>
  <PxModalSomeoneElse action="shop" id="shopping-for-someone-else-modal" />
  <PxModalSomeoneElse action="apply" id="applying-for-someone-else-modal" />
</template>

<style scoped></style>
